import { render, staticRenderFns } from "./MarkSentToSite.vue?vue&type=template&id=56ddf8ac&"
import script from "./MarkSentToSite.vue?vue&type=script&lang=js&"
export * from "./MarkSentToSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports